"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.PaginationList = void 0;
var react_1 = __importDefault(require("react"));
var ramda_1 = require("ramda");
var Container_1 = require("../Container/Container");
var PaginationContext_1 = require("./PaginationContext");
var PaginationList = function (_a) {
    var className = _a.className, PageItem = _a.PageItem, rest = __rest(_a, ["className", "PageItem"]);
    var _b = PaginationContext_1.usePaginationContext(), page = _b.page, pageStart = _b.pageStart, pageEnd = _b.pageEnd, changePage = _b.changePage;
    return (react_1["default"].createElement(Container_1.Container, __assign({ className: ['pagination_list', className] }, rest), ramda_1.times(function (p) {
        var pageNumber = p + pageStart;
        return (react_1["default"].createElement(PageItem, { key: pageNumber, className: "pagination_link", page: pageNumber, isCurrent: pageNumber === page, onClick: function () {
                changePage(pageNumber);
            } }));
    }, pageEnd - pageStart + 1)));
};
exports.PaginationList = PaginationList;
//# sourceMappingURL=PaginationList.js.map